module.exports = __webpack_public_path__ + "static/media/key-replacement.8af27387.png";